/* Announcement countdown.
   rolling: counts down from the chosen number of hours, remembers its end time in
            localStorage (pdp-ann-end) so it survives page loads, and starts again at zero.
            If the browser blocks storage it still counts down, it just starts over on reload.
   fixed:   counts down to the end date. Each block holds two digits, so shoppers see the timer
            once fewer than 100 hours are left. It hides after the date has passed.
            A date without a time ends at the end of that day in the shopper's time zone.
            In the theme editor an unreadable date shows dashes instead of nothing. */
(function () {
  var KEY = 'pdp-ann-end';
  var HOUR = 3600000;
  var MAX_LEFT = 100 * HOUR; // two digits of hours: 99:59:59 is the most a block can show

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Date.parse reads a bare date as midnight UTC, which is the evening before for US shoppers.
  // Read it as the end of that day in local time instead. Returns NaN for anything unreadable.
  function parseEnd(raw) {
    raw = (raw || '').trim();
    if (!raw) return NaN;
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
    if (d) {
      var month = +d[2] - 1, day = +d[3];
      var t = new Date(+d[1], month, day, 23, 59, 59);
      return t.getMonth() === month && t.getDate() === day ? t.getTime() : NaN;
    }
    // Safari only reads the "T" form, so turn "2026-12-01 23:59" into "2026-12-01T23:59".
    return Date.parse(raw.replace(/^(\d{4}-\d{2}-\d{2})\s+(?=\d)/, '$1T'));
  }

  function readStored() {
    try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; }
  }

  function init(root) {
    if (root.hasAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '');

    var timer = root.querySelector('[data-fm-lc-timer]');
    if (!timer) return;
    var hEl = timer.querySelector('[data-fm-lc-h]');
    var mEl = timer.querySelector('[data-fm-lc-m]');
    var sEl = timer.querySelector('[data-fm-lc-s]');

    var fixed = root.getAttribute('data-timer-mode') === 'fixed';
    var duration = (parseInt(root.getAttribute('data-hours'), 10) || 2) * HOUR;
    var fixedEnd = parseEnd(root.getAttribute('data-end'));
    var editing = !!(window.Shopify && window.Shopify.designMode);
    // Kept here as well as in storage, so the countdown still moves when storage is blocked.
    var rollingStop = readStored();
    var id = 0;

    function rollingLeft() {
      var now = Date.now();
      // Passed: another tab or copy of this section may already have started the next round.
      if (rollingStop && rollingStop <= now) rollingStop = readStored();
      if (!rollingStop || rollingStop <= now || rollingStop - now > duration) {
        rollingStop = now + duration;
        try { localStorage.setItem(KEY, String(rollingStop)); } catch (e) {}
      }
      return rollingStop - now;
    }

    function show(left) {
      var total = Math.max(0, Math.floor(left / 1000));
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    function dashes() {
      if (hEl) hEl.textContent = '--';
      if (mEl) mEl.textContent = '--';
      if (sEl) sEl.textContent = '--';
    }

    // Returns false when the timer is finished and the interval can stop.
    function tick() {
      // Stop if the section was removed from the page (theme editor).
      if (!document.body.contains(root)) return false;
      var left;
      if (fixed) {
        if (isNaN(fixedEnd)) {
          // Shoppers see no timer. The editor shows dashes so the mistake is easy to spot.
          timer.hidden = !editing;
          if (editing) dashes();
          return false;
        }
        left = fixedEnd - Date.now();
        if (left <= 0) { timer.hidden = true; return false; }
        if (left >= MAX_LEFT) {
          // Too far away for two digits of hours. Hidden for shoppers until it fits;
          // the editor shows the largest value so the style can still be checked.
          timer.hidden = !editing;
          left = MAX_LEFT - 1000;
        } else {
          timer.hidden = false;
        }
      } else {
        left = rollingLeft();
      }
      show(left);
      return true;
    }

    if (tick()) {
      id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
    }
  }

  function boot() { document.querySelectorAll('[data-pdp-announcement]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
